import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import FileToUpload from "../../../domains/FiletoUpload";
import { SLICE_NAME } from "./types";

interface AttachmentsState {
  isLoading: boolean
  hasFileUploadError: boolean
  attachmentsToUpload: Array<FileToUpload>
  fileToUpload: FileToUpload | null
  hasErrorDeletingFile: boolean
}

const initialState: AttachmentsState = {
  attachmentsToUpload: [],
  isLoading: false,
  hasFileUploadError: false,
  fileToUpload: null,
  hasErrorDeletingFile: false
};

export const attachmentsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    addAttachments: (state, action: PayloadAction<Array<FileToUpload>>) => {
      const updatedArray = [...state.attachmentsToUpload, ...action.payload];
      state.attachmentsToUpload = updatedArray;
    },
    setFileToUploadInfo: (
      state,
      action: PayloadAction<{
        fileId: string
        uploadLink: string
        temporaryId: string
      }>,
    ) => {
      const updatedFileInfo = state.attachmentsToUpload.find(
        attachments => attachments.temporaryId === action.payload.temporaryId,
      );

      if (updatedFileInfo) {
        updatedFileInfo.temporaryId = action.payload.temporaryId;
        updatedFileInfo.uploadLink = action.payload.uploadLink;
        updatedFileInfo.fileId = action.payload.fileId;
      }

    },
    clearAttachments: state => {
      state.attachmentsToUpload = initialState.attachmentsToUpload;
    },
    deleteFileSuccess: (state, action: PayloadAction<string>) => {
      const newFiles = state.attachmentsToUpload.filter(
        attachment => attachment.fileId !== action.payload,
      );

      state.attachmentsToUpload = newFiles;
    },
    deleteFileError: (state) => {
      state.hasErrorDeletingFile = true;
    }
  },
});

export const {
  addAttachments,
  setFileToUploadInfo,
  clearAttachments,
  deleteFileError,
  deleteFileSuccess,
} = attachmentsSlice.actions;

export default attachmentsSlice.reducer;
